import {Component} from "react"
import {withRouter} from "react-router-dom"

@withRouter
export default class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const preventScrollToTop = this.props.location.state ? this.props.location.state.preventScrollToTop !== true : true

    if ( this.props.location !== prevProps.location && preventScrollToTop ) {
      window.scrollTo( 0, 0 )
    }
  }

  render() {
    return null
  }
}




// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.js